export default "__VITE_ASSET__DjiHd7Nb__"